import { createAsyncThunk } from '@reduxjs/toolkit';
import ASYNC_STATUSES from '@src/store/asyncStatuses';

import { ACTIONS_PREFIX } from '../constants';

const pureState = {
	fetchFavourSpaces: {
		data: null,
		error: null,
		status: ASYNC_STATUSES.IDLE,
	},
};

const fetchFavourSpaces = createAsyncThunk(
	`${ACTIONS_PREFIX}/fetchFavourSpaces`,
	async ({ params }, { extra }) => {
		const { api } = extra;
		const { ids, ...restParams } = params;
		const formedIds = Array.isArray(ids) ? ids : [ids];
		const response = await api.apiv3.get(
			`loftcard/${formedIds.join(',')}`,
			{ params: restParams },
		);

		return response.data;
	},
);

const reducerFactory = (builder) => {
	builder.addCase(fetchFavourSpaces.pending, (state) => {
		return {
			...state,
			fetchFavourSpaces: {
				...state.fetchFavourSpaces,
				status: ASYNC_STATUSES.PENDING,
			},
		};
	});

	builder.addCase(fetchFavourSpaces.fulfilled, (state, action) => {
		return {
			...state,
			fetchFavourSpaces: {
				...state.fetchFavourSpaces,
				status: ASYNC_STATUSES.RESOLVED,
				data: action.payload,
				error: null,
			},
		};
	});

	builder.addCase(fetchFavourSpaces.rejected, (state, action) => {
		const { meta } = action;
		return {
			...state,
			fetchFavourSpaces: {
				...state.fetchFavourSpaces,
				data: null,
				status: ASYNC_STATUSES.REJECTED,
				error: { ...action.error, arg: meta.arg },
			},
		};
	});
};

export default {
	pureState,
	reducerFactory,
	action: fetchFavourSpaces,
};
